module.exports = __webpack_public_path__ + "img/error-icon.cecdee05.svg";